import { flattenDeep } from 'lodash';
import { DASHBOARD_TABS } from '../../../utils/constants';
import { pageConfigurationFactory } from './pageConfigurationFactory';

const getCurrentUserCardsIds = user => {
    return flattenDeep(
        Object.values(DASHBOARD_TABS).map(page => {
            return pageConfigurationFactory(page, user).map(section => section.cards);
        })
    );
};

export { getCurrentUserCardsIds };
